// extracted by mini-css-extract-plugin
export var fadeIn = "_gf-1";
export var modalContent = "_gf-3";
export var overlay = "_gf-0";
export var popoverContent = "_gf-2";
export var results = "_gf-5";
export var searchInputWrapper = "_gf-4";